const getAttachmentFiles = (dataItem, attachments) => {
  if (!dataItem.attachments) return []
  return dataItem.attachments.filter((attachment) => attachments.includes(attachment.uuid))
}

export default getAttachmentFiles
